// Best taglines chosen from the user's list — used across the site with rotation
export const TAGLINES_EN = [
  "Where Frustration Finds Understanding.",
  "Calm in the Storm of Conflict.",
  "Turning Conflict into Clarity.",
  "Clarity When You Need It Most.",
  "Safe Space for Your Story.",
  "From Frustration to Freedom.",
  "Hear. Help. Heal. Together.",
  "Trusted Counsel for Tough Times.",
  "Patience, Power, Progress.",
  "Solutions with Compassion.",
];

export const TAGLINES_HI = [
  "जहाँ बेचैनी को समझ मिले।",
  "उलझनों के तूफ़ान में शांति।",
  "टकराव से स्पष्टता तक।",
  "स्पष्टता — ठीक जब सबसे ज़रूरत हो।",
  "आपकी कहानी के लिए एक सुरक्षित कोना।",
  "बेचैनी से आज़ादी तक।",
  "सुनें। मदद करें। मिलकर सँवारें।",
  "मुश्किल समय की भरोसेमंद सलाह।",
  "धैर्य, शक्ति, प्रगति।",
  "करुणा के साथ समाधान।",
];

export const MARQUEE_TAGLINES_EN = [
  "Where Frustration Finds Understanding",
  "•",
  "Calm in the Storm of Conflict",
  "•",
  "Turning Conflict into Clarity",
  "•",
  "Safe Space for Your Story",
  "•",
  "Trusted Counsel for Tough Times",
  "•",
];

export const MARQUEE_TAGLINES_HI = [
  "जहाँ बेचैनी को समझ मिले",
  "•",
  "उलझनों के तूफ़ान में शांति",
  "•",
  "टकराव से स्पष्टता तक",
  "•",
  "आपकी कहानी के लिए सुरक्षित कोना",
  "•",
  "मुश्किल समय की भरोसेमंद सलाह",
  "•",
];
